import { Fragment } from "react";
import { makeStyles } from "tss-react/mui";
import { MiIcon, MiIconButton, MiProfilePicture } from "@miplatform/components";
import { IUserListItemResponse } from "@miplatform/types";
import { mdiPencilOutline } from "@mdi/js";
import { Box, Divider, Typography } from "@mui/material";

export const CalendarUserCard = ({
  user,
  isReadOnly,
  onEditClick,
}: Readonly<CalendarUserCardProps>) => {
  const { classes, theme } = useStyles();

  return (
    <Box className={classes.configListCardContent}>
      <Box className={classes.configListCard}>
        <Box className={classes.configListCardContent}>
          <Box className={classes.configListCardText}>
            <Box className={classes.configListCardTextLine}>
              <MiProfilePicture
                name={user.name}
                size={20}
                fontSize={12}
                sx={{
                  borderRadius: "4px",
                  minWidth: 20,
                  backgroundColor: theme.palette.primary.main,
                }}
              />
              <Typography
                noWrap
                variant="HD2"
                color={theme.palette.primary.main}
              >
                {user.name}
              </Typography>
              <Box className={classes.rolesContainer}>
                {user.roles?.slice(0, 5).map((role) => (
                  <Fragment key={role.id}>
                    <Divider orientation="vertical" sx={{ height: 20 }} />
                    <Typography variant="BD2" color={theme.palette.grey.medium}>
                      {role.name}
                    </Typography>
                  </Fragment>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
        {!isReadOnly && (
          <Box className={classes.configListCardContent}>
            <MiIconButton onClick={() => onEditClick(user)}>
              <MiIcon
                path={mdiPencilOutline}
                color={theme.palette.primary.main}
              />
            </MiIconButton>
          </Box>
        )}
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  configListCard: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.12)",
    flex: 1,
    overflow: "auto",
  },
  configListCardContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  configListCardText: {
    display: "flex",
    flexDirection: "column",
  },
  configListCardTextLine: {
    height: 16,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",

    gap: theme.spacing(1),
  },
  rolesContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(1),
    overflow: "auto",
    whiteSpace: "nowrap",
  },
}));

export interface CalendarUserCardProps {
  user: IUserListItemResponse;
  isReadOnly?: boolean;
  onEditClick: (user: IUserListItemResponse) => void;
}
